import { Route, Routes, Navigate } from "react-router";
import "./custom.css";
import "./assets/css/site.css";
import Login from "./components/Login";
import MyLogin from "./components/MyLogin";
import Unauthorized from "./components/Unauthorized";
import RequireAuth from "./components/RequireAuth";
import RequireElevatedAuth from "./components/RequireElevatedAuth";

import Layout from "./components/Layout";

import Home from "./components/Home";
import MyHome from "./components/MyHome";

import UserReportsIndex from "./components/UserReports/UserReportsIndex";
import UserReportDetail from "./components/UserReports/UserReportDetail";

import ReportLayout from "./components/ReportLayout";

import ISOSummaryReportForm from "./components/Reports/ISOSummary/ISOSummaryReportForm";
import ISOSummaryFilter from "./components/Reports/ISOSummary/ISOSummaryFilter";
import ISOSummaryViewOptions from "./components/Reports/ISOSummary/ISOSummaryViewOptions";
import ISOSummaryPreview from "./components/Reports/ISOSummary/ISOSummaryPreview";
import ISODetailReportForm from "./components/Reports/ISODetail/ISODetailReportForm";
import ISODetailFilter from "./components/Reports/ISODetail/ISODetailFilter";
import ISODetailViewOptions from "./components/Reports/ISODetail/ISODetailViewOptions";
import ISODetailPreview from "./components/Reports/ISODetail/ISODetailPreview";
import KentuckyDetailReportForm from "./components/Reports/KentuckyDetail/KentuckyDetailReportForm";
import KentuckyDetailFilter from "./components/Reports/KentuckyDetail/KentuckyDetailFilter";
import KentuckyDetailViewOptions from "./components/Reports/KentuckyDetail/KentuckyDetailViewOptions";
import KentuckyDetailPreview from "./components/Reports/KentuckyDetail/KentuckyDetailPreview";
import CaliforniaJACReportForm from "./components/Reports/CaliforniaJAC/CaliforniaJACReportForm";
import CaliforniaJACFilter from "./components/Reports/CaliforniaJAC/CaliforniaJACFilter";
import CaliforniaJACViewOptions from "./components/Reports/CaliforniaJAC/CaliforniaJACViewOptions";
import CaliforniaJACPreview from "./components/Reports/CaliforniaJAC/CaliforniaJACPreview";
import ISAAuditReportForm from "./components/Reports/ISAAudit/ISAAuditReportForm";
import ISAAuditFilter from "./components/Reports/ISAAudit/ISAAuditFilter";
import ISAAuditViewOptions from "./components/Reports/ISAAudit/ISAAuditViewOptions";
import ISAAuditPreview from "./components/Reports/ISAAudit/ISAAuditPreview";
import WSRBSummaryReportForm from "./components/Reports/WSRBSummary/WSRBSummaryReportForm";
import WSRBSummaryFilter from "./components/Reports/WSRBSummary/WSRBSummaryFilter";
import WSRBSummaryViewOptions from "./components/Reports/WSRBSummary/WSRBSummaryViewOptions";
import WSRBSummaryPreview from "./components/Reports/WSRBSummary/WSRBSummaryPreview";
import WSRBDetailReportForm from "./components/Reports/WSRBDetail/WSRBDetailReportForm";
import WSRBDetailFilter from "./components/Reports/WSRBDetail/WSRBDetailFilter";
import WSRBDetailViewOptions from "./components/Reports/WSRBDetail/WSRBDetailViewOptions";
import WSRBDetailPreview from "./components/Reports/WSRBDetail/WSRBDetailPreview";

import DetailedCompletionsReportForm from "./components/Reports/DetailedCompletions/DetailedCompletionsReportForm";
import DetailedCompletionsFilter from "./components/Reports/DetailedCompletions/DetailedCompletionsFilter";
import DetailedCompletionsViewOptions from "./components/Reports/DetailedCompletions/DetailedCompletionsViewOptions";
import DetailedCompletionsPreview from "./components/Reports/DetailedCompletions/DetailedCompletionsPreview";
import LearningPlanReportForm from "./components/Reports/LearningPlan/LearningPlanReportForm";
import LearningPlanFilter from "./components/Reports/LearningPlan/LearningPlanFilter";
import LearningPlanViewOptions from "./components/Reports/LearningPlan/LearningPlanViewOptions";
import LearningPlanPreview from "./components/Reports/LearningPlan/LearningPlanPreview";
import ChecklistReportForm from "./components/Reports/Checklist/ChecklistReportForm";
import ChecklistFilter from "./components/Reports/Checklist/ChecklistFilter";
import ChecklistViewOptions from "./components/Reports/Checklist/ChecklistViewOptions";
import ChecklistPreview from "./components/Reports/Checklist/ChecklistPreview";

import MyLearningPlanReportForm from "./components/MyReports/LearningPlan/LearningPlanReportForm";
import MyLearningPlanFilter from "./components/MyReports/LearningPlan/LearningPlanFilter";
import MyLearningPlanViewOptions from "./components/MyReports/LearningPlan/LearningPlanViewOptions";
import MyLearningPlanPreview from "./components/MyReports/LearningPlan/LearningPlanPreview";
import MyDetailedCompletionsReportForm from "./components/MyReports/DetailedCompletions/DetailedCompletionsReportForm";
import MyDetailedCompletionsFilter from "./components/MyReports/DetailedCompletions/DetailedCompletionsFilter";
import MyDetailedCompletionsViewOptions from "./components/MyReports/DetailedCompletions/DetailedCompletionsViewOptions";
import MyDetailedCompletionsPreview from "./components/MyReports/DetailedCompletions/DetailedCompletionsPreview";

function App() {
    return (
        <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/mylogin" element={<MyLogin />} />
            <Route path="/unauthorized" element={<Unauthorized />} />
            <Route element={<RequireAuth />}>
                <Route element={<Layout />}>
                    <Route path="/myreports/" element={<MyHome />} />
                    <Route path="/myreports/reports" element={<UserReportsIndex />} />
                    <Route path="/myreports/reports/:id" element={<UserReportDetail />} />
                </Route>
                <Route element={<ReportLayout />}>
                    <Route element={<MyLearningPlanFilter />}>
                        <Route
                            path="/myreports/learningplan/form"
                            element={<MyLearningPlanReportForm />}
                        />
                        <Route
                            path="/myreports/learningplan/options"
                            element={<MyLearningPlanViewOptions />}
                        />
                        <Route
                            path="/myreports/learningplan/preview"
                            element={<MyLearningPlanPreview />}
                        />
                    </Route>
                    <Route element={<MyDetailedCompletionsFilter />}>
                        <Route
                            path="/myreports/detailedcompletions/form"
                            element={<MyDetailedCompletionsReportForm />}
                        />
                        <Route
                            path="/myreports/detailedcompletions/options"
                            element={<MyDetailedCompletionsViewOptions />}
                        />
                        <Route
                            path="/myreports/detailedcompletions/preview"
                            element={<MyDetailedCompletionsPreview />}
                        />
                    </Route>
                </Route>
            </Route>
            <Route element={<RequireElevatedAuth />}>
                <Route element={<Layout />}>
                    <Route path="/" element={<Home />} />
                    <Route path="/reports" element={<UserReportsIndex />} />
                    <Route path="/reports/:id" element={<UserReportDetail />} />
                </Route>
                <Route element={<ReportLayout />}>
                    <Route element={<ISOSummaryFilter />}>
                        <Route path="/isosummary/form" element={<ISOSummaryReportForm />} />
                        <Route
                            path="/isosummary/options"
                            element={<ISOSummaryViewOptions />}
                        />
                        <Route path="/isosummary/preview" element={<ISOSummaryPreview />} />
                    </Route>
                    <Route element={<ISODetailFilter />}>
                        <Route path="/isodetail/form" element={<ISODetailReportForm />} />
                        <Route
                            path="/isodetail/options"
                            element={<ISODetailViewOptions />}
                        />
                        <Route path="/isodetail/preview" element={<ISODetailPreview />} />
                    </Route>
                    <Route element={<KentuckyDetailFilter />}>
                        <Route
                            path="/kentuckydetail/form"
                            element={<KentuckyDetailReportForm />}
                        />
                        <Route
                            path="/kentuckydetail/options"
                            element={<KentuckyDetailViewOptions />}
                        />
                        <Route
                            path="/kentuckydetail/preview"
                            element={<KentuckyDetailPreview />}
                        />
                    </Route>
                    <Route element={<CaliforniaJACFilter />}>
                        <Route
                            path="/californiajac/form"
                            element={<CaliforniaJACReportForm />}
                        />
                        <Route
                            path="/californiajac/options"
                            element={<CaliforniaJACViewOptions />}
                        />
                        <Route
                            path="/californiajac/preview"
                            element={<CaliforniaJACPreview />}
                        />
                    </Route>
                    {/*<Route element={<WSRBSummaryFilter />}>*/}
                    {/*    <Route path="/wsrbsummary/form" element={<WSRBSummaryReportForm />} />*/}
                    {/*    <Route*/}
                    {/*        path="/wsrbsummary/options"*/}
                    {/*        element={<WSRBSummaryViewOptions />}*/}
                    {/*    />*/}
                    {/*    <Route path="/wsrbsummary/preview" element={<WSRBSummaryPreview />} />*/}
                    {/*</Route>*/}
                    {/*<Route element={<WSRBDetailFilter />}>*/}
                    {/*    <Route path="/wsrbdetail/form" element={<WSRBDetailReportForm />} />*/}
                    {/*    <Route*/}
                    {/*        path="/wsrbdetail/options"*/}
                    {/*        element={<WSRBDetailViewOptions />}*/}
                    {/*    />*/}
                    {/*    <Route path="/wsrbdetail/preview" element={<WSRBDetailPreview />} />*/}
                    {/*</Route>*/}
                    <Route element={<ISAAuditFilter />}>
                        <Route
                            path="/isaaudit/form"
                            element={<ISAAuditReportForm />}
                        />
                        <Route
                            path="/isaaudit/options"
                            element={<ISAAuditViewOptions />}
                        />
                        <Route
                            path="/isaaudit/preview"
                            element={<ISAAuditPreview />}
                        />
                    </Route>
                    <Route element={<DetailedCompletionsFilter />}>
                        <Route
                            path="/detailedcompletions/form"
                            element={<DetailedCompletionsReportForm />}
                        />
                        <Route
                            path="/detailedcompletions/options"
                            element={<DetailedCompletionsViewOptions />}
                        />
                        <Route
                            path="/detailedcompletions/preview"
                            element={<DetailedCompletionsPreview />}
                        />
                    </Route>
                    <Route element={<LearningPlanFilter />}>
                        <Route
                            path="/learningplan/form"
                            element={<LearningPlanReportForm />}
                        />
                        <Route
                            path="/learningplan/options"
                            element={<LearningPlanViewOptions />}
                        />
                        <Route
                            path="/learningplan/preview"
                            element={<LearningPlanPreview />}
                        />
                    </Route>
                    <Route element={<ChecklistFilter />}>
                        <Route path="/checklist/form" element={<ChecklistReportForm />} />
                        <Route
                            path="/checklist/options"
                            element={<ChecklistViewOptions />}
                        />
                        <Route path="/checklist/preview" element={<ChecklistPreview />} />
                    </Route>
                    <Route element={<WSRBSummaryFilter />}>
                        <Route path="/wsrbsummary/form" element={<WSRBSummaryReportForm />} />
                        <Route
                            path="/wsrbsummary/options"
                            element={<WSRBSummaryViewOptions />}
                        />
                        <Route path="/wsrbsummary/preview" element={<WSRBSummaryPreview />} />
                    </Route>
                    <Route element={<WSRBDetailFilter />}>
                        <Route path="/wsrbdetail/form" element={<WSRBDetailReportForm />} />
                        <Route
                            path="/wsrbdetail/options"
                            element={<WSRBDetailViewOptions />}
                        />
                        <Route path="/wsrbdetail/preview" element={<WSRBDetailPreview />} />
                    </Route>
                </Route>
            </Route>
        </Routes>
    );
}

export default App;
